import * as React from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";

export interface ConfirmationModalRawProps {
  id: string;
  clickEliminar: boolean;
  keepMounted: boolean;
  clickCancelar: boolean;
  guardar: boolean;
  guardarMessage?: string;
  open: boolean;
  onClose: () => void;
  onEliminar?: () => void;
  saveForm: () => void;
  isDirty: boolean;
  handleDeshacerCancelar: () => void;
}

const AlertDialog: React.FC<ConfirmationModalRawProps> = ({
  saveForm,
  open,
  onClose,
  isDirty,
  handleDeshacerCancelar,
  clickCancelar,
  clickEliminar,
  onEliminar,
  guardar,
  guardarMessage,
}) => {
  const { t } = useTranslation(["confirmationModal", "common"]);
  const handleClose = () => {
    isDirty ? handleDeshacerCancelar() : onClose();
  };

  const handleEliminar = () => {
    onEliminar && onEliminar();
  };

  const handleSaveForm = () => {
    saveForm();
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        keepMounted
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {clickCancelar && (
          <DialogTitle id="alert-dialog-title">
            {t("cancelChangesTitle", { ns: "confirmationModal" })}
          </DialogTitle>
        )}
        {clickEliminar && !guardar && (
          <DialogTitle id="alert-dialog-title">
            {t("deletePeriodTypeTitle", { ns: "confirmationModal" })}
          </DialogTitle>
        )}
        {guardar && (!clickCancelar || !clickEliminar) && (
          <DialogTitle id="alert-dialog-title">{guardarMessage}</DialogTitle>
        )}
        {/* <DialogContent>
          {isDirty ? (
            <DialogContentText id="alert-dialog-description">
              ¿Querés cancelar los cambios realizados?
            </DialogContentText>
          ) : (
            <DialogContentText id="alert-dialog-description">
              ¿Querés guardar los cambios realizados?
            </DialogContentText>
          )}
        </DialogContent> */}
        {clickCancelar && (
          <DialogActions>
            {isDirty ? (
              <>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleDeshacerCancelar}
                  autoFocus
                >
                  {t("actions.yes", { ns: "common" })}
                </Button>
                <Button color="error" variant="contained" onClick={onClose}>
                  {t("actions.no", { ns: "common" })}
                </Button>
              </>
            ) : (
              <>
                <Button color="error" variant="contained" onClick={handleClose}>
                  {t("actions.no", { ns: "common" })}
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={onClose}
                  autoFocus
                >
                  {t("actions.yes", { ns: "common" })}
                </Button>
              </>
            )}
          </DialogActions>
        )}
        {clickEliminar && !guardar && (
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={handleEliminar}
              autoFocus
            >
              {t("actions.yes", { ns: "common" })}
            </Button>
            <Button color="error" variant="contained" onClick={onClose}>
              {t("actions.no", { ns: "common" })}
            </Button>
          </DialogActions>
        )}
        {guardar && (!clickCancelar || !clickEliminar) && (
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={handleSaveForm}
              autoFocus
            >
              {t("actions.yes", { ns: "common" })}
            </Button>
            <Button color="error" variant="contained" onClick={onClose}>
              {t("actions.no", { ns: "common" })}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
};

type ConfirmationModalType = {
  open: boolean;
  clickEliminar?: boolean;
  guardar?: boolean;
  guardarMessage?: string;
  onOpen: () => void;
  onEliminar?: () => Promise<void | null>;
  saveForm: (value?: string) => void;
  onClose: (value?: string) => void;
  isDirty: boolean;
  clickCancelar: boolean;
  handleDeshacerCancelar: () => void;
};

const ConfirmationModal: React.FC<ConfirmationModalType> = ({
  saveForm,
  open,
  onClose,
  onOpen,
  isDirty,
  clickCancelar,
  handleDeshacerCancelar,
  clickEliminar,
  onEliminar,
  guardar,
  guardarMessage,
}) => {
  const { t } = useTranslation("confirmationModal");
  return (
    <Box sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}>
      <AlertDialog
        id="ringtone-menu"
        keepMounted
        open={open}
        onClose={onClose}
        saveForm={saveForm}
        isDirty={isDirty}
        handleDeshacerCancelar={handleDeshacerCancelar}
        clickCancelar={clickCancelar}
        clickEliminar={clickEliminar || false}
        guardar={guardar || false}
        onEliminar={onEliminar}
        guardarMessage={guardarMessage || t("defaultGuardarMessage")}
      />
    </Box>
  );
};

export default ConfirmationModal;
